import { useMutation, useQueryClient } from "@tanstack/react-query";
import MarkFavoriteTestPayload from "../../../models/API/requestModels/MarkFavoriteTestPayload.model";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import toastMessages from "../../helpers/toastMessage";

function useMarkFavoriteTest() {
  const authState = useOktaAuth()?.authState;
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["markFavoriteTests"],
    mutationFn: (data: MarkFavoriteTestPayload) => {
      return axiosInstance.post(`/v1/test-type/favorite-test`, data, {
        headers: {
          Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
        },
      });
    },
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ["favoriteTests"],
      });
      // toastMessages.success("Test marked as favorite");
    },
    onError: (error) => {
      toastMessages.error(error.message);
    },
  });
}

export default useMarkFavoriteTest;
